import React from "react";

import { FeaturedChallengesContainer } from "./featuredChallenges.style";
import CtaButton from "../../ctaButton/ctaButton.component";
import ChallengeDeckCard from "../challengeDeckCard/challengeDeckCard.component";
import useMedia from "../../../hooks/useMedia";

const FeaturedChallenges = ({ data }) => {
  const { isTablet, isSmallDesktop } = useMedia();
  const slicedData = isTablet || isSmallDesktop ? data.slice(0, 2) : data;
  return (
    <FeaturedChallengesContainer
      id="featured"
      data-anchor="Featured Challenges"
      className="bootstrap_5"
    >
      <h1>Featured Challenges</h1>
      <div className="decks">
        {slicedData.map((challenge) => (
          <ChallengeDeckCard key={challenge.id} data={challenge} />
        ))}
      </div>
      <div>
        <a href="/challenges">
          <CtaButton>Find a Challenge</CtaButton>
        </a>
        <a href="/innovate/start">
          <CtaButton transparent="true">Create a Challenge</CtaButton>
        </a>
      </div>
    </FeaturedChallengesContainer>
  );
};

export default FeaturedChallenges;
